
export class UserActivityLogModel{
    userId:string;
    firstName:string;
    lastName :string;
    action : string;
    actionId:string;
    actionItem:string; 
    itemName:string; 
    orgId:string;   
    groupId :string;
    roleId:string;
    surveyId : string; 
    oldValue:string;   
    newValue :string;
    createdOn : Date;
    ModifiedOn :Date;
    title : string;
    description:string;
    navigationLink : string; 
}